import { render } from "./Ipra.vue?vue&type=template&id=527bd82f&scoped=true"
import script from "./Ipra.vue?vue&type=script&lang=js"
export * from "./Ipra.vue?vue&type=script&lang=js"

import "./Ipra.vue?vue&type=style&index=0&id=527bd82f&scoped=true&lang=css"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527bd82f"]])

export default __exports__